import { BaseComponent } from '../base-component'
import {
  requestAnimationFrameAfterStyleAndLayout,
  transitionToPromise,
  $el,
  strToBool,
} from '../../utils/utils'

const CLASS_IS_OPENED = 'is-opened'
const CLASS_IS_ANIMATING = 'is-animating'

const SELECTOR_OVERLAY = '.bottom-sheet__overlay'
const SELECTOR_CONTENT = '.bottom-sheet__content'
const SELECTOR_CLOSE_BUTTON = '.bottom-sheet__close-button'

const TOUCH_MOVE_THRESHOLD = 45

export class BottomSheet extends BaseComponent {
  content: HTMLElement
  contentTouchStart: number
  contentTouchEnd: number

  mountComponent(): void {
    super.mountComponent()

    this.content = $el(SELECTOR_CONTENT, this)

    this.addListener(this, 'click', this.handleClick)
    this.addListener(this.content, 'touchstart', this.handleContentTouchStart)
    this.addListener(this.content, 'touchmove', this.handleContentTouchMove)
    this.addListener(this.content, 'touchend', this.handleContentTouchEnd)
  }

  unmountComponent(): void {
    super.unmountComponent()

    this.removeListener(this, 'click', this.handleClick)
    this.removeListener(
      this.content,
      'touchstart',
      this.handleContentTouchStart,
    )
    this.removeListener(this.content, 'touchmove', this.handleContentTouchMove)
    this.removeListener(this.content, 'touchend', this.handleContentTouchEnd)
  }

  handleContentTouchStart = (e: TouchEvent) => {
    this.contentTouchStart = e.targetTouches[0].clientY
    this.contentTouchEnd = 0
  }

  handleContentTouchMove = (e: TouchEvent) =>
    (this.contentTouchEnd = e.targetTouches[0].clientY)

  handleContentTouchEnd = (e: TouchEvent) => {
    if (this.contentTouchEnd - this.contentTouchStart > TOUCH_MOVE_THRESHOLD) {
      this.hide()
    }
  }

  handleClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement

    if (target.closest(SELECTOR_OVERLAY)) {
      this.handleOverlayClick()
    } else if (target.closest(SELECTOR_CLOSE_BUTTON)) {
      this.handleCloseButtonClick()
    }
  }

  handleOverlayClick = () => {
    if (this.closeOnOverlay) {
      this.hide()
    }
  }

  handleCloseButtonClick = () => this.hide()

  show = async () => {
    const { classList } = this

    classList.toggle(CLASS_IS_ANIMATING, true)
    await requestAnimationFrameAfterStyleAndLayout()
    classList.toggle(CLASS_IS_ANIMATING, false)
    classList.toggle(CLASS_IS_OPENED, true)
  }

  hide = async () => {
    const { classList } = this

    classList.toggle(CLASS_IS_ANIMATING, true)
    classList.toggle(CLASS_IS_OPENED, false)

    await Promise.all([
      transitionToPromise($el(SELECTOR_OVERLAY)),
      transitionToPromise($el(SELECTOR_CONTENT)),
    ])

    classList.toggle(CLASS_IS_ANIMATING, false)
  }

  toggle = async () => {
    if (this.classList.contains(CLASS_IS_OPENED)) {
      await this.hide()
    } else {
      await this.show()
    }
  }

  get closeOnOverlay() {
    return strToBool(this.dataset.closeOnOverlay)
  }
}
